import { render } from "./DetailsCard.vue?vue&type=template&id=6cb62284&scoped=true"
import script from "./DetailsCard.vue?vue&type=script&lang=js"
export * from "./DetailsCard.vue?vue&type=script&lang=js"

import "./DetailsCard.vue?vue&type=style&index=0&id=6cb62284&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cb62284"]])

export default __exports__